
import Vue from 'vue'
import PaymentPage from './PaymentPage.vue'

export default Vue.extend({
   name: 'StorePaymentApp',
   components: {
      PaymentPage,
   },
})
